export default __webpack_public_path__ + "static/media/jiosaavan.d6fa10b2.jpg";